<template>
  <input ref="select" />
</template>

<script>
import TomSelect from 'tom-select';

const taxCodes = [
  { id: 'GST', label: 'GST' },
  { id: 'FRE', label: 'FRE' },
  { id: 'GNR', label: 'GNR' },
];

export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      control: null,
    };
  },
  mounted() {
    this.init();
  },
  beforeUnmount() {
    if (this.control) {
      this.control.destroy();
    }
  },
  watch: {
    modelValue(newValue) {
      if (this.control && this.control.getValue() !== newValue) {
        this.control.setValue(newValue || '', true);
      }
    },
  },
  methods: {
    init() {
      this.control = new TomSelect(this.$refs.select, {
        maxItems: 1,
        valueField: 'id',
        labelField: 'label',
        searchField: 'label',
        options: taxCodes,
        onChange: value => {
          console.log('value', value);
          this.$emit('update:modelValue', value);
        },
      });

      if (this.modelValue) {
        const option = taxCodes.find(option => option.id === this.modelValue);

        if (option) {
          this.control.addOption(option);
          this.control.setValue(option.id, true);
        }
      }
    },
  },
};
</script>
